import React, {useState} from 'react';
import {useIntl} from 'react-intl';
import ButtonAction from '../../../_common/components/ButtonAction';
import {tooltips as TTS} from '../../../_common/constants/tooltips';
import {
  subjects as S,
  permissionTypes as T
} from '../../../_common/constants/permissionSubjects';
import {toAbsoluteUrl} from '../../../../../_metronic/_helpers';
import {can} from '../../../_common/components/Permissions';
import {useDispatch} from 'react-redux';
import {freezeOrder, unFreezeOrder} from '../../_redux/actions/OrdersPageTableActions';
import ModalContainer from '../../../_common/components/ModalContainer';
import ModalHeader from '../../../_common/components/ModalHeader';
import ModalButtonsContainer from '../../../_common/components/ModalButtonsContainer';
import {buttonCancel, buttonSubmit, largeButtonsPadding} from '../../../_common/styles/styles';

const PopupFreezeOrder = ({data}) => {
  const intl = useIntl();
  const dispatch = useDispatch();
  const [show, setShow] = useState(false);
  const handleCloseModal = () => setShow(false);
  const handleShowModal = () => setShow(true);
  const {orderNumber, status} = data;
  const isOrderCompleted = status === 3;
  const isOrderFrozen = status === 4;

  const handleFreezeOrder = () => {
    if (isOrderFrozen) {
      dispatch(unFreezeOrder(orderNumber));
    } else {
      dispatch(freezeOrder(orderNumber));
    }
    handleCloseModal();
  };
  const popupMessage = [
    intl.formatMessage({
      id: `orders-page-popup-message-${isOrderFrozen ? 'unfreeze' : 'freeze'}`,
      defaultMessage: `Should I ${isOrderFrozen ? 'unfreeze' : 'freeze'} the order`}),
    orderNumber ? ' - ' : '',
    orderNumber,
    '?'
  ].filter(Boolean).join('');

  return (
    <>
      <ButtonAction
        variant={'icon'}
        iconButtonType={isOrderFrozen ? 'warning' : 'cancel'}
        title={isOrderFrozen ? TTS.UNFREEZE_ORDER : TTS.FREEZE_ORDER}
        disabled={!can(T.FULL, S.ORDERS_PAGE) || isOrderCompleted}
        onClick={handleShowModal}
        label={<img src={toAbsoluteUrl(`media/common/${isOrderFrozen ? 'Unlock_yellow.svg' : 'Lock_grey.svg'}`)} alt="freeze"/>}
        customClassnames={'mx-2'}
      />
      <ModalContainer show={show} onClose={handleCloseModal} size={'md'}>
        <ModalHeader header={popupMessage}/>
        <ModalButtonsContainer customClassnames={largeButtonsPadding}>
          <ButtonAction
            variant={'cancel'}
            onClick={handleCloseModal}
            label={intl.formatMessage({id: 'button-decline', defaultMessage: 'No'})}
            customClassnames={buttonCancel}
          />
          <ButtonAction
            onClick={handleFreezeOrder}
            useIcon={'/media/common/Check-in-circle_white.svg'}
            label={intl.formatMessage({id: 'yes', defaultMessage: 'Yes'})}
            customClassnames={buttonSubmit}
          />
        </ModalButtonsContainer>
      </ModalContainer>
    </>
  );
};

export default PopupFreezeOrder;
